import { aboutData } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1">
            <h2 className="text-xl md:text-3xl font-heading text-foreground-50 mb-2">{aboutData.title}</h2>
            <p className="text-primary-500 text-sm md:text-base font-medium mb-6">{aboutData.subtitle}</p>
            <div className="space-y-3">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i} className="text-foreground-400 text-sm leading-relaxed">{p}</p>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-md rounded-lg overflow-hidden">
            <img
              src={aboutData.image}
              alt="天美麻花星空影视 - 极致观影体验"
              className="w-full h-auto rounded-lg"
              onError={(e) => {
                (e.currentTarget.parentElement as HTMLElement).style.display = "none";
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}